import { useChateauImages } from "@/hooks/useChateauImages";
import { useSumoImages } from "@/hooks/useSumoImages";
import { useSumos } from "@/hooks/useSumos";
import { useChateaux } from "@/hooks/useChateaux";
import princessCastle from "@/assets/princess-castle.jpg";
import sumoWrestling from "@/assets/sumo-wrestling.jpg";

export interface ServiceData {
  id: string;
  title: string;
  description: string;
  image: string;
  price: string;
  features: string[];
  themes: string[];
}

/**
 * Custom hook for managing service data
 */
export const useServiceData = () => {
  const { chateaux } = useChateaux();
  const { sumos } = useSumos();
  
  // Get first château for image
  const firstChateau = chateaux.find(c => c.is_visible) || chateaux[0];
  const { imageUrls: chateauImages } = useChateauImages(firstChateau?.id || '');
  
  // Get first sumo for image
  const firstSumo = sumos.find(s => s.is_visible) || sumos[0];
  const { imageUrls: sumoImages } = useSumoImages(firstSumo?.id || '');

  const services: ServiceData[] = [
    {
      id: "chateaux",
      title: "Châteaux Gonflables",
      description: "Une sélection incroyable de châteaux gonflables pour tous les goûts",
      image: chateauImages.length > 0 ? chateauImages[0] : princessCastle,
      price: "À partir de 30€",
      features: [
        "Diable pour transport", 
        "Bâche pour le sol", 
        "Fiche explicative", 
        "Piquets d'ancrage", 
        "Soufflerie incluse", 
        "Plus accessoires si nécessaires"
      ],
      themes: ["Princesse", "Dino", "Disco", "Pingouin", "Vache", "Grenouille", "Twister"]
    },
    {
      id: "sumos",
      title: "Sumos", 
      description: "Combat amusant et sécurisé dans des costumes sumos gonflables",
      image: sumoImages.length > 0 ? sumoImages[0] : sumoWrestling,
      price: firstSumo?.price || "50€",
      features: [
        "Costumes inclus", 
        "Bâche de protection", 
        "Adultes (min 150cm)", 
        "Tapis de sécurité"
      ],
      themes: []
    }
  ];

  return {
    services,
    isLoading: !chateaux.length && !sumos.length
  };
};